import api from './api';
import { fetchPage } from './pagedParams';

const storeService = {
  // Get all stores (filtered by user access)
  getAllStores: async () => {
    const response = await api.get('/admin/stores');
    return response.data;
  },

  // Get active stores only
  getActiveStores: async () => {
    const response = await api.get('/admin/stores/active');
    return response.data;
  },

  // Search stores
  searchStores: async (query) => {
    const response = await api.get(`/admin/stores/search?query=${query}`);
    return response.data;
  },

  // Get stores the current user has access to
  getMyStores: async () => {
    const response = await api.get('/admin/stores/my-stores');
    return response.data;
  },

  // Get single store
  getStoreById: async (id) => {
    const response = await api.get(`/admin/stores/${id}`);
    return response.data;
  },

  // Get store with user details (admin only)
  getStoreWithUsers: async (id) => {
    const response = await api.get(`/admin/stores/${id}/with-users`);
    return response.data;
  },

  // Create store
  createStore: async (storeData) => {
    const response = await api.post('/admin/stores', storeData);
    return response.data;
  },

  // Update store
  updateStore: async (id, storeData) => {
    const response = await api.put(`/admin/stores/${id}`, storeData);
    return response.data;
  },

  // Delete store
  deleteStore: async (id) => {
    await api.delete(`/admin/stores/${id}`);
  },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getStoresPage: (params) => fetchPage('/admin/stores/paged', params),

};

export default storeService;